/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateFileNodeRequest } from '../../models/create-file-node-request';
import { FileNodeDto } from '../../models/file-node-dto';

export interface CreateFileNode$Params {
      body: CreateFileNodeRequest
}

export function createFileNode(http: HttpClient, rootUrl: string, params: CreateFileNode$Params, context?: HttpContext): Observable<StrictHttpResponse<FileNodeDto>> {
  const rb = new RequestBuilder(rootUrl, createFileNode.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileNodeDto>;
    })
  );
}

createFileNode.PATH = '/v0/fileSystem';
